export const UPDATE_FORM_PAGE = "SIStepForm/UPDATE_FORM_PAGE";
export const SET_FIELD_VALID = "Common/forms/SET_FIELD_VALID";
export const updateFormPage = (page) => ({
  type: UPDATE_FORM_PAGE,
  page,
});
export const setFieldValid = (name, valid) => ({
  type: SET_FIELD_VALID,
  payload: {
    name,
    valid,
  },
});
